import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const MessageBox = ({ border, children }) => {
  const messageBoxClass = classnames('message-box', {
    'border-1 border-color-grey--light border-radius-l': border,
  });

  return (
    <div className={messageBoxClass}>
      {children}
    </div>
  );
};

MessageBox.propTypes = {
  border: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]).isRequired,
};

export default MessageBox;



// WEBPACK FOOTER //
// ./library/app/components/Global/Messages/MessageBox.js